<template>
  <footer class="footer bg-dark text-white py-5 mt-4">
    <div class="container">
      <!-- Footer Top Section -->
      <div class="row mt-4">
        <!-- Description Section -->
        <div class="col-md-4">
          <h4 class="footer-title">
            <span class="brand-text">SOLDIERS</span>
            <span class="brand-highlight">Gym</span>
          </h4>
          <p>
            Soldier's Gym is one of the best fitness centers in Hosur and Attibele. Our customized designs will help you enjoy the best experience of your life.
          </p>

          <!-- Follow Us & Social Media Links -->
          <h5 class="footer-subtitle">Follow Us</h5>
          <div class="social-links">
            <!-- Facebook Icon -->
            <a href="https://www.facebook.com/profile.php?id=100065008534222" target="_blank" class="text-white me-3">
              <font-awesome-icon :icon="['fab', 'facebook']" size="2x" />
            </a>

            <!-- Instagram Icon -->
            <a href="https://www.instagram.com/soldiers.gym?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" class="text-white me-3">
              <font-awesome-icon :icon="['fab', 'instagram']" size="2x" />
            </a>
          </div>
        </div>

        <!-- Footer Middle Section (Contact Info) -->
        <div class="col-md-4">
          <h5 class="footer-subtitle">For More Info</h5>
          <p>
            <strong>Mr. Gopal</strong><br />
            <br />
            P: +91 99522 96949 <br />
            E: <a href="mailto:gopal@gmail.com" class="text-white">gopal@gmail.com</a>
          </p>
        </div>

        <!-- Corporate Office Section -->
        <div class="col-md-4">
          <h5 class="footer-subtitle">Our Location</h5>
          <p>
            <strong>Address:</strong> Pragathi Complex, Above SBH Bank, 
            Sadhashiv Nagar Attibele, Bengaluru, <br>
            Karnataka -562107, India <br />
            P: +91 70225 38917 <br />
            E: <a href="mailto:gopal@gmail.com" class="text-white">gopal@gmail.com</a>
          </p>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="text-center mt-4">
        <p>&copy; 2024 SoldierGym - All Rights Reserved. Designed by MithraTechX Solutions</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterPage",
};
</script>

<style scoped>
/* Footer Styling */
.footer {
  background-color: #212121; /* Dark background for contrast */
  color: #fff;
  padding: 30px 0;
}

.footer-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
  font-weight: 800; /* Bold text for titles */
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #ffc107; /* Golden color for the brand */
  border-bottom: 2px solid #ffc107; /* Underline effect */
  padding-bottom: 8px;
}

.footer-title .brand-text {
  margin-right: 10px; /* Add space between "SOLDIERS" and "Gym" */
}

.footer-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  color: #f1f1f1; /* Slightly lighter color */
  margin-bottom: 15px;
}

.footer a {
  color: #f1f1f1;
  text-decoration: none;
}

.footer a:hover {
  color: #ffd700;
  text-decoration: underline;
}

.social-links a {
  font-size: 1.8rem;
  color: #f1f1f1;
  margin-right: 15px;
  transition: all 0.3s ease;
}

.social-links a:hover {
  color: #ffd700;
  transform: scale(1.1);
}

/* Footer Responsive Styling */
@media (max-width: 767px) {
  .footer .row {
    text-align: center;
  }
  .social-links {
    display: flex;
    justify-content: center;
  }
}

/* Additional Spacing and Styling Adjustments */
.text-center p {
  font-size: 0.9rem;
  color: #ccc;
  margin-top: 30px;
}

.text-center p a {
  color: #ffd700;
  text-decoration: none;
}

.text-center p a:hover {
  text-decoration: underline;
}
</style>
